import { __assign } from 'tslib';
import MuiRadio from '@mui/material/Radio';
import React from 'react';
import { u as useFormControlContext } from '../../form-control-context-fc570f22.js';

var Radio = React.forwardRef(function Radio(props, ref) {
    var setControl = useFormControlContext().setControl;
    React.useEffect(function () {
        setControl('radio');
    }, [setControl]);
    return React.createElement(MuiRadio, __assign({}, props, { ref: ref }));
});

export { Radio as default };
